module.exports = __webpack_public_path__ + "static/1.3cancel-2d9f0159ad8da794b8a7c650015ad075.gif";